import React from 'react';

export const Icons = {
    More: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="5" r="1.5" fill={color}/>
            <circle cx="12" cy="12" r="1.5" fill={color}/>
            <circle cx="12" cy="19" r="1.5" fill={color}/>
        </svg>
    ),
    Plus: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <line x1="12" y1="5" x2="12" y2="19" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
            <line x1="5" y1="12" x2="19" y2="12" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
        </svg>
    ),
    Clip: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Image: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="18" height="18" rx="3" stroke={color} strokeWidth="2"/>
            <circle cx="8.5" cy="8.5" r="1.5" fill={color}/>
            <path d="M21 15l-5-5L5 21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Camera: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="13" r="4" stroke={color} strokeWidth="2"/>
        </svg>
    ),
    VideoCamera: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <polygon points="23 7 16 12 23 17 23 7" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <rect x="1" y="5" width="15" height="14" rx="2" stroke={color} strokeWidth="2"/>
        </svg>
    ),
    // Videocámara tachada — cámara apagada en llamada
    VideoCameraOff: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="1" y1="1" x2="23" y2="23" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    // Cambiar entre cámara frontal/trasera
    CameraSwitch: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 14a3 3 0 0 0 3 3c1.3 0 2.4-.8 2.8-2M15 12a3 3 0 0 0-3-3c-1.3 0-2.4.8-2.8 2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="14.5 9.5 15 12 12.5 11.5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="9.5 16.5 9 14 11.5 14.5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    // Subtítulos (CC)
    Subtitles: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="2" y="5" width="20" height="14" rx="2" stroke={color} strokeWidth="2"/>
            <line x1="6" y1="11" x2="9" y2="11" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="6" y1="15" x2="13" y2="15" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="13" y1="11" x2="18" y2="11" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="16" y1="15" x2="18" y2="15" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    // Fototraductor — encuadre tipo escáner con líneas de texto dentro.
    // Visualmente: "apunto la cámara a un texto y lo lee". (Lucide: scan-text)
    ScanText: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M3 7V5a2 2 0 0 1 2-2h2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M17 3h2a2 2 0 0 1 2 2v2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21 17v2a2 2 0 0 1-2 2h-2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M7 21H5a2 2 0 0 1-2-2v-2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M7 8h8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M7 12h10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M7 16h6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    // Teléfono (receptor). Mismo estilo outline que el resto — stroke 2,
    // linecap round. Usado en los botones de llamada del header del chat.
    Phone: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Microphone: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="9" y="2" width="6" height="11" rx="3" stroke={color} strokeWidth="2"/>
            <path d="M19 10v2a7 7 0 01-14 0v-2" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="12" y1="19" x2="12" y2="23" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="8" y1="23" x2="16" y2="23" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    // Micrófono tachado — indica mute
    MicrophoneOff: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <line x1="1" y1="1" x2="23" y2="23" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="12" y1="19" x2="12" y2="23" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="8" y1="23" x2="16" y2="23" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    MicrophoneActive: ({ size = 20, color = '#ff4757' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="9" y="2" width="6" height="11" rx="3" fill={color} stroke={color} strokeWidth="2"/>
            <path d="M19 10v2a7 7 0 01-14 0v-2" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="12" y1="19" x2="12" y2="23" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="8" y1="23" x2="16" y2="23" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    VoiceTranslate: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M12 2a3 3 0 00-3 3v7a3 3 0 006 0V5a3 3 0 00-3-3z" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <path d="M19 10v2a7 7 0 01-14 0v-2" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="12" y1="19" x2="12" y2="22" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <path d="M18 19l2 2-2 2" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15 21h5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    ),
    VoiceTranslateActive: ({ size = 20, color = '#00B4D8' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M12 2a3 3 0 00-3 3v7a3 3 0 006 0V5a3 3 0 00-3-3z" fill={color} stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <path d="M19 10v2a7 7 0 01-14 0v-2" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="12" y1="19" x2="12" y2="22" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <path d="M18 19l2 2-2 2" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15 21h5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    ),
    Send: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M22 2L11 13" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M22 2L15 22l-4-9-9-4 20-7z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Document: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 2v6h6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="16" y1="13" x2="8" y2="13" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="16" y1="17" x2="8" y2="17" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    Play: ({ size = 14, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
            <polygon points="5 3 19 12 5 21 5 3"/>
        </svg>
    ),
    Pause: ({ size = 14, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
            <rect x="6" y="4" width="4" height="16" rx="1"/>
            <rect x="14" y="4" width="4" height="16" rx="1"/>
        </svg>
    ),
    Stop: ({ size = 14, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
            <rect x="4" y="4" width="16" height="16" rx="2"/>
        </svg>
    ),
    Speaker: ({ size = 14, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M19.07 4.93a10 10 0 010 14.14" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <path d="M15.54 8.46a5 5 0 010 7.07" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    Reply: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <polyline points="9 17 4 12 9 7" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M20 18v-2a4 4 0 00-4-4H4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Forward: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <polyline points="15 17 20 12 15 7" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M4 18v-2a4 4 0 014-4h12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Trash: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <polyline points="3 6 5 6 21 6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M19 6l-1 14H6L5 6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10 11v6M14 11v6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <path d="M9 6V4h6v2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Close: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <line x1="18" y1="6" x2="6" y2="18" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="6" y1="6" x2="18" y2="18" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    Search: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="8" stroke={color} strokeWidth="2"/>
            <line x1="21" y1="21" x2="16.65" y2="16.65" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    Download: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="7 10 12 15 17 10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="12" y1="15" x2="12" y2="3" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    Edit: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Share: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="16 6 12 2 8 6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="12" y1="2" x2="12" y2="15" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    ChevronUp: ({ size = 14, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <polyline points="18 15 12 9 6 15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    ChevronDown: ({ size = 14, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <polyline points="6 9 12 15 18 9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    ChevronRight: ({ size = 14, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <polyline points="9 18 15 12 9 6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Save: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="17 21 17 13 7 13 7 21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="7 3 7 8 15 8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    ArrowBack: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M19 12H5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 19l-7-7 7-7" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Group: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="9" cy="7" r="4" stroke={color} strokeWidth="2"/>
            <path d="M23 21v-2a4 4 0 00-3-3.87" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 3.13a4 4 0 010 7.75" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    User: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="7" r="4" stroke={color} strokeWidth="2"/>
        </svg>
    ),
    LogOut: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="16 17 21 12 16 7" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="21" y1="12" x2="9" y2="12" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    Crown: ({ size = 16, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M2 20h20" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <path d="M4 20l2-8 6 4 6-4 2 8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="8" r="2" fill={color}/>
            <circle cx="4" cy="10" r="1.5" fill={color}/>
            <circle cx="20" cy="10" r="1.5" fill={color}/>
        </svg>
    ),
    Star: ({ size = 16, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
        </svg>
    ),
    Check: ({ size = 16, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <polyline points="20 6 9 17 4 12" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Bell: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13.73 21a2 2 0 01-3.46 0" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    BellOff: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M13.73 21a2 2 0 01-3.46 0" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M18.63 13A17.89 17.89 0 0118 8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6.26 6.26A5.86 5.86 0 006 8c0 7-3 9-3 9h14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M18 8a6 6 0 00-9.33-5" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="1" y1="1" x2="23" y2="23" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    Heart: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    HeartFill: ({ size = 18, color = '#F5A000' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
            <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
        </svg>
    ),
    Block: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2"/>
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    Info: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2"/>
            <line x1="12" y1="8" x2="12" y2="12" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="12" y1="16" x2="12.01" y2="16" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    Calendar: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="3" y="5" width="18" height="16" rx="2" stroke={color} strokeWidth="2"/>
            <line x1="3" y1="10" x2="21" y2="10" stroke={color} strokeWidth="2"/>
            <line x1="8" y1="3" x2="8" y2="7" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="16" y1="3" x2="16" y2="7" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    DoorExit: ({ size = 18, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M13 4H6a2 2 0 00-2 2v14a2 2 0 002 2h7" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M17 8l4 4-4 4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="21" y1="12" x2="9" y2="12" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    Female: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="8" r="5" stroke={color} strokeWidth="2"/>
            <line x1="12" y1="13" x2="12" y2="21" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="9" y1="18" x2="15" y2="18" stroke={color} strokeWidth="2" strokeLinecap="round"/>
        </svg>
    ),
    Male: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="10" cy="14" r="5" stroke={color} strokeWidth="2"/>
            <line x1="19" y1="5" x2="14.14" y2="9.86" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <polyline points="15 5 19 5 19 9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Pulse: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <polyline points="2 12 6 12 8 6 12 18 14 9 16 12 22 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Settings: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="2"/>
            <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Home: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M3 12L12 4l9 8M5 10v10h14V10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    List: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <line x1="8" y1="6" x2="21" y2="6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="8" y1="12" x2="21" y2="12" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <line x1="8" y1="18" x2="21" y2="18" stroke={color} strokeWidth="2" strokeLinecap="round"/>
            <circle cx="4" cy="6" r="1.5" fill={color}/>
            <circle cx="4" cy="12" r="1.5" fill={color}/>
            <circle cx="4" cy="18" r="1.5" fill={color}/>
        </svg>
    ),
    Globe: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2"/>
            <path d="M3 12h18M12 3a14 14 0 010 18M12 3a14 14 0 000 18" stroke={color} strokeWidth="2"/>
        </svg>
    ),
    Users: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="9" cy="7" r="4" stroke={color} strokeWidth="2"/>
            <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Link: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    Store: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M3 9l2-6h14l2 6M3 9v11a1 1 0 001 1h16a1 1 0 001-1V9M3 9h18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 21v-6h6v6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    ImageOutline: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke={color} strokeWidth="2"/>
            <circle cx="8.5" cy="8.5" r="1.5" fill={color}/>
            <path d="M21 15l-5-5L5 21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    // Gamepad estilizado: cuerpo redondeado + cruceta a la izquierda y 2 botones a la derecha
    Gamepad: ({ size = 20, color = 'currentColor' }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M6 8h12a4 4 0 014 4v2a4 4 0 01-4 4h-1.5a2 2 0 01-1.8-1.1L14 15h-4l-.7 1.9A2 2 0 017.5 18H6a4 4 0 01-4-4v-2a4 4 0 014-4z" stroke={color} strokeWidth="2" strokeLinejoin="round"/>
            <path d="M6.5 12h3M8 10.5v3" stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
            <circle cx="15.5" cy="11.5" r="1" fill={color}/>
            <circle cx="17.5" cy="13.5" r="1" fill={color}/>
        </svg>
    ),
};

export default Icons;